import React from 'react';

import './assignAccounts.scss';
import { DataTable, TableColumn } from '@ampol/design-system';

interface AssignAccountsProps {
  data,
  isLoading,
  onColumnSort,
  onSelectionChange,
  errors,
  selectedAccounts,
  isReadOnly,
  selectionDisabled?,
  selectAll?,
} 

/**
 * Assigned Account list
 * @param data Data to display
 * @param isLoading Is data in process of loading
 * @param onColumnSort Event triggered when column is sorted
 * @param onSelectionChange Event triggered when item selection changes
 * @param selectionDisabled Toggle item selection on or off
 * @param selectAll Trigger select all toggle
 * @param errors Loading of data encountered an error
 * @param selectedAccounts List of accounts that are selected
 * @param isReadOnly no selections can be made if set to true
 *
 * @returns JSX Element
 */
const AssignAccounts = ({
  data,
  isLoading,
  onColumnSort,
  onSelectionChange,
  selectionDisabled,
  selectAll,
  errors,
  selectedAccounts,
  isReadOnly,
}: AssignAccountsProps) => {

  const getAccountLevel = (level) => {
    if (level === 'B')
      return 'PARENT';
    else if (level === 'A') {
      return 'GRANDPARENT';
    }
    return 'CHILD';
  };

  const getColumns = (): TableColumn[] => {
    return [
      {
        header: 'Account Number',
        accessorKey: 'contractNumber',
        id: 'AccountNumber',
        defaultSorted: 'desc',
      },
      {
        header: 'Account Name',
        accessorKey: 'contractName',
        id: 'AccountName',
      },
      {
        header: 'Level',
        accessorFn: (rowData) => getAccountLevel(rowData.level),
        id: 'AccountLevel',
        disableSort: true
      },
    ];
  };

  return (
    <div className="assign-accounts-table">
      <DataTable
        caption="Assigned Accounts list"
        columns={getColumns()}
        data={data}
        isLoading={isLoading}
        tableVariant={'list'}
        onColumnSorted={onColumnSort}
        isSelectable={!selectionDisabled}
        onSelect={onSelectionChange}
        selectAll={selectAll}
        rowSelectedFn={item => selectedAccounts && !!selectedAccounts[item.contractNumber] }
        rowSelectionDisabledFn={() => isReadOnly}
        noDataMessage={errors ? 'Oops! There was an error. Please try again later or report this issue.' : 'No accounts available'}
      />
    </div>
  );
};

export default AssignAccounts;
